export default [
  {
    path: '/tasks/task',
    name: 'task',
    component: () => import('@/views/tasks/tasks/Task.vue'),
  },
]
